import { FORMULA_TYPES } from 'constants/all';

import request from 'utils/request';

export default {
  compilePricingFormula: async ({ formula, supplierId }) =>
    await request.post('/formula/compile/v2', {
      formula,
      type: FORMULA_TYPES.ADD_ON,
      supplierId,
    }),
  create: async (groupId, data) =>
    await request.post(`/suppliers/${groupId}/add_on_definitions`, data),
  delete: async (addOnId) =>
    await request.delete(`/suppliers/add_on_definitions/${addOnId}`),
  get: async (addOnId) =>
    await request.get(`/suppliers/add_on_definitions/${addOnId}`),
  list: async (groupId, params = {}) =>
    await request.get(`/suppliers/${groupId}/add_on_definitions`, params),
  update: async (addOnId, data) =>
    await request.patch(`/suppliers/add_on_definitions/${addOnId}`, data),
  updatePricingFormula: async (addOnId, formula, revertedFrom) =>
    await request.patch(`/suppliers/add_on_definitions/${addOnId}/formula`, {
      formula,
      revertedFrom,
    }),
  updateVariable: async (variableId, data) =>
    await request.patch(`/formulas/variables/${variableId}`, data),
};
